import { Pipe, PipeTransform } from '@angular/core';

import { getSearchResultParams } from './search.functions';

@Pipe({
  name: 'searchResultParams'
})
export class SearchResultParamsPipe implements PipeTransform {
    transform(result: any): any {
        return getSearchResultParams(result);
    }
};